export default __webpack_public_path__ + "static/media/player.06f68eaa.png";